<div class="container-plan" >
  <div *ngFor="let plan of plans">
  <div class="container-card-plan">
    <div class="box-title">
      <div class="mt-2">
        <img src="/assets/icono-plans/{{ plan.imageplan }}" alt="" style="width: 60px; height: 60px;"/>
        <button class="buttonMiplan" *ngIf="plan.idplan === this.user_plan.plan_id">Mi Plan</button>  
      </div>
      <span class="copec-bold-30 mt-2">{{ plan.titleplan }}</span>
      <span class="copec-rg-14 mt-2"
        >{{ plan.descriptionplan }}</span
      >
    </div>
    <div class="box-body mt-5">
      <span class="copec-bold-14 mt-2">Aporte trabajador</span>
      <div class="copec-bold-30 mt-0">
        {{ plan.contributionplan }} 
      </div>
      <div class="costAdd">
        {{plan.periodicityplan}}
      </div>
      <div class="copec-lg-14 mb-2">{{plan.aditionalcostbeneficiariestext}}
      </div>
      <div class="d-flex justify-content-center">
        <button 
        class='plans-button' 
        [disabled]=" plan.idplan === user_plan.plan_id " 
        (click)="openModalPlanInfo(plan.idplan)">
        {{ plan.idplan === user_plan.plan_id ? 'Mi Plan': 'Quiero este plan' }}
      </button> 
         <div *ngIf="openModalAlert && plan.idplan === idPlanOpenModal">
          <app-modal-alert
          [mensaje]="mensajeModalAlerta"
          [icono]="iconoModalAlerta "
          [cambioAplanDuo]="downgradeToPlanDuo"
          (closeModalPlan)="closeModalInfo($event)">
          </app-modal-alert>
        </div>

         <div *ngIf="openModal && plan.idplan === idPlanOpenModal && idPlanOpenModal > this.user_plan.plan_id" >   
          <app-modal-plans
            [titleplan] = plan.titleplan
            [iconplan] = plan.imageplan
            [imagen] ="imagen"
            [descriptionplan] = "descriptionUpgrade"
            [processplan] = "detailsUpgrade"
            [idplanCambio]=plan.idplan
            (closeModalPlan)="closeModalInfo($event)"
          ></app-modal-plans> 
        </div>
        <div *ngIf="openModal && plan.idplan === idPlanOpenModal && idPlanOpenModal < this.user_plan.plan_id" > 
          <app-modal-downgrade
            [titleplan] = plan.titleplan
            [iconplan] = plan.imageplan
            [imagen]="imagen"
            [description]="descriptionDowngrade"
            [process]="processDowngrade"
            [idplan]=plan.idplan
            [miplan]="user_plan.plan_id"
            (closeModalPlan)="closeModalInfo($event)"
            (openModaldesaffiliation)="goDesaffiliation($event)"
            [nombreMiPlan]= "user_plan.descripcion_plan"
            [cambioAplanDuo]="downgradeToPlanDuo"

          ></app-modal-downgrade>
        </div> 
        <div *ngIf="openModaldesaffiliation && plan.idplan === idPlanOpenModal && idPlanOpenModal < this.user_plan.plan_id">
          <app-modal-form-desaffiliation
            [idplan]=plan.idplan
            [miplan]="user_plan.descripcion_plan"
            (closeModalPlan)="closeModalInfo($event)"
          ></app-modal-form-desaffiliation>
         </div>
      </div>
    </div>
    <div class="box-benefits mt-4">
      <span >{{ plan.advantageDescription }}</span>
      <div class="box-benefit mt-2" *ngFor="let advantage_plan of plan.advantagesPlan">
        <img src="/assets/icono-plans/icono-checkPlans.svg" alt="" />
        <span>{{ advantage_plan.nombre }}</span>
      </div>
    </div>
    </div>
  </div>
</div>
